import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { handleRevokeAVPApplication, handleRevokeApplication,
  handleSuspendAVPApplication, handleSuspendApplication } from '../redux/action';
import { RevokeApplication, SuspendApplication } from './ActionCompo';


export default function SuspendRevokeComp(props) {
  const { handleAllStateValue, actionDetails, updateId, adpDetails, avpDetailsPage, getLatestAvpDetails,
    handleGetLatestADPDetails } = props;
  const { suspendApplicationAction, revokeApplicationAction,
    suspendAVPApplicationAction, revokeAVPApplicationAction } = useSelector(state => state?.permitManagement);
  const dispatch = useDispatch();

  const handleErrorChanged = (fieldId, value) => {
    handleAllStateValue(prvSt => ({
      ...prvSt,
      suspendErrors: {
        ...prvSt?.suspendErrors,
        [fieldId]: value
      }
    }));
    if (fieldId !== 'suspend_untill_date') {
      setTimeout(() => {
        handleAllStateValue(prevSt => ({
          ...prevSt,
          suspendErrors: {
            ...prevSt?.suspendErrors,
            // eslint-disable-next-line no-nested-ternary
            suspend_untill_date: prevSt?.suspendErrors?.suspend_type_select !== 'date' ? false
              : prevSt?.suspendErrors?.suspend_type_select === 'date'
                ? !(prevSt?.suspendErrors.suspend_untill_date !== '')
                : prevSt?.suspendErrors?.suspendErrors?.suspend_untill_date
          }
        }));
      }, 100);
    }
  };

  const handleActionSuspenRevoke = (actionType) => {
    if (actionType === 'suspend') {
      const noErrors = actionDetails?.suspendErrors && Object.keys(actionDetails?.suspendErrors)
      ?.every(fieldError => actionDetails?.suspendErrors[fieldError] === false);
      if (noErrors) {
        const payload = {
          suspension_reason: actionDetails?.suspend?.suspendRemarks,
          suspended_until: actionDetails?.suspend?.suspend_type_select === 'date' ? actionDetails?.suspend?.suspend_untill_date : null
        };
        if (adpDetails) {
          dispatch(handleSuspendApplication(updateId, payload));
        } else if (avpDetailsPage) {
          dispatch(handleSuspendAVPApplication(updateId, payload));
        }
      } else {
        handleAllStateValue({
          ...actionDetails,
          suspendFieldError: true
        });
      }
    } else if (actionType === 'revoke') {
      const noErrors = actionDetails?.revokeErrors && actionDetails?.revokeErrors?.revokeRemarks !== true;
      if (noErrors) {
        const payload = {
          revoke_reason: actionDetails?.revoke?.revokeRemarks
        };
        if (adpDetails) {
          dispatch(handleRevokeApplication(updateId, payload));
        } else if (avpDetailsPage) {
          dispatch(handleRevokeAVPApplication(updateId, payload));
        }
      } else {
        handleAllStateValue({
          ...actionDetails,
          revokeFieldError: true
        });
      }
    }
  };

  const handleSuspendAnswer = (value, fieldId) => {
    handleAllStateValue(prevSt => ({
      ...prevSt,
      suspend: {
        ...prevSt?.suspend,
        [fieldId]: value
      }
    }));
  };

  const handleCloseSuspendComp = useCallback(() => {
    handleAllStateValue(prevSt => ({
      ...prevSt,
      suspend: {
        ...prevSt?.suspend,
        openSuspendModal: false,
        suspendRemarks: '',
        suspend_type_select: '',
        suspend_untill_date: ''
      },
      suspendErrors: {
        suspend_type_select: true,
        suspend_untill_date: true,
        suspendRemarks: true
      },
      reactive: {
        openReactive: false
      },
      suspendFieldError: false
    }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFalseErrors = () => {
    handleAllStateValue(prevSt => ({
      ...prevSt,
      suspend: {
        ...prevSt?.suspend,
        openSuspendModal: false,
        suspendRemarks: '',
        suspend_type_select: '',
        suspend_untill_date: ''
      },
      suspendErrors: {
        suspend_type_select: true,
        suspend_untill_date: true,
        suspendRemarks: true
      },
      suspendFieldError: false
    }));
  };

  const handleCloseActionComp = useCallback(() => {
    handleAllStateValue(prevSt => ({
      ...prevSt,
      revoke: {
        ...prevSt?.revoke,
        operRevokeModal: false,
        revokeRemarks: ''
      },
      revokeErrors: {
        ...prevSt?.revoke,
        revokeRemarks: true
      },
      revokeFieldError: false
    }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleActionsAnswerComp = (value) => {
    handleAllStateValue(prevSt => ({
      ...prevSt,
      revoke: {
        ...prevSt?.revoke,
        revokeRemarks: value
      }
    }));
  };

  const handleRevokeError = (fieldId, value) => {
    handleAllStateValue(prvSt => ({
      ...prvSt,
      revokeErrors: {
        ...prvSt?.revokeErrors,
        [fieldId]: value
      }
    }));
  };
  // console.log(suspendAction, 'suspendAction', revokeAction, 'revokeAction');

  // AFTER REVOKE --> DETAILS API
  useEffect(() => {
    if (revokeApplicationAction?.loading === false && revokeApplicationAction?.success === true && handleGetLatestADPDetails) {
      handleGetLatestADPDetails();
      handleCloseActionComp();
    }
  }, [revokeApplicationAction, handleGetLatestADPDetails, handleCloseActionComp]);

  useEffect(() => {
    if (revokeAVPApplicationAction?.loading === false && revokeAVPApplicationAction?.success === true && getLatestAvpDetails) {
      getLatestAvpDetails();
      handleCloseActionComp();
    }
  }, [revokeAVPApplicationAction, getLatestAvpDetails, handleCloseActionComp]);

  // AFTER SUSPEND --> DETAILS API
  useEffect(() => {
    if (suspendApplicationAction?.loading === false && suspendApplicationAction?.success === true && handleGetLatestADPDetails) {
      handleGetLatestADPDetails();
      handleCloseSuspendComp();
    }
  }, [suspendApplicationAction, handleGetLatestADPDetails, handleCloseSuspendComp, adpDetails]);

  useEffect(() => {
    if (suspendAVPApplicationAction?.loading === false && suspendAVPApplicationAction?.success === true && getLatestAvpDetails) {
      handleCloseSuspendComp();
      getLatestAvpDetails();
    }
  }, [suspendAVPApplicationAction, getLatestAvpDetails, handleCloseSuspendComp]);

  return (
    <div>
      {actionDetails?.suspend?.openSuspendModal && (
        <SuspendApplication
          suspenPopupOpen={actionDetails?.suspend?.openSuspendModal}
          handleCloseSuspendComp={handleCloseSuspendComp}
          handleFalseErrors={handleFalseErrors}
          handleSuspendAnswer={handleSuspendAnswer}
          suspendAction={suspendApplicationAction}
          suspendAVPAction={suspendAVPApplicationAction}
          suspend_type_select={actionDetails?.suspend?.suspend_type_select}
          suspendFieldError={actionDetails?.suspendFieldError}
          suspend_untill_date={actionDetails?.suspend?.suspend_untill_date}
          suspendRemarks={actionDetails?.suspend?.suspendRemarks}
          handleActionSuspenRevoke={handleActionSuspenRevoke}
          handleFieldErrorChanged={handleErrorChanged}
        />
      )}
      {actionDetails?.revoke?.operRevokeModal && (
        <RevokeApplication
          revokePopupOpen={actionDetails.revoke?.operRevokeModal}
          handleCloseActionComp={handleCloseActionComp}
          handleActionsAnswerComp={handleActionsAnswerComp}
          revokeRemarks={actionDetails?.revoke?.revokeRemarks}
          revokeFieldError={actionDetails?.revokeFieldError}
          handleActionSuspenRevoke={handleActionSuspenRevoke}
          revokeAction={revokeApplicationAction}
          revokeAVPAction={revokeAVPApplicationAction}
          handleFieldErrorChanged={handleRevokeError}
        />
      )}
    </div>
  );
}
